import { forwardRef } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const FinalCtaSection = forwardRef<HTMLDivElement>((_, ref) => (
  <section ref={ref} className="text-center space-y-6 pb-8">
    <h2 className="text-2xl font-display font-bold">
      Klar for mindre mas – og mer mestring?
    </h2>
    <ul className="text-sm text-muted-foreground space-y-1">
      <li>✔ Tar under 2 minutter</li>
      <li>✔ Barn trenger ikke e-post</li>
      <li>✔ Gratis å starte</li>
    </ul>
    <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
      <Button size="lg" asChild>
        <Link to="/register">Kom i gang gratis</Link>
      </Button>
      <Button variant="outline" size="lg" asChild>
        <Link to="/login">Logg inn</Link>
      </Button>
    </div>
  </section>
));

FinalCtaSection.displayName = "FinalCtaSection";
